import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40d7468c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "forbidden-join-wrapper" }
const _hoisted_2 = { class: "inline-text" }
const _hoisted_3 = { class: "forbidden-join__company-info" }

import { reactive, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { NImage, NEllipsis } from 'naive-ui'
import ChangeAccountBtn from '@teams/common/components/changeAccountBtn'
import defaultCompany from '@/assets/defaultCompany.png'


export default /*#__PURE__*/_defineComponent({
  __name: 'forbiddenJoin',
  props: {
    avatar: null,
    companyName: null,
    onCancel: null
  },
  setup(__props: any) {


const { t } = useI18n()
// eslint-disable-next-line
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.forbiddenJoin.${key}`, ...params)
}

const i18n = reactive({
  beforeSuffix: computed(() => {
    return $tt('beforeSuffix')
  }),
  afterSuffix: computed(() => {
    return $tt('afterSuffix')
  })
})

return (_ctx: any,_cache: any) => {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NSpace = _resolveComponent("NSpace")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NEllipsis), {
      class: "forbidden-join__tips",
      style: {"max-width":"384px"},
      "line-clamp": 2,
      tooltip: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(i18n.beforeSuffix) + " ", 1),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(NImage), {
              width: "22",
              height: "22",
              src: __props.avatar,
              "fallback-src": _unref(defaultCompany),
              class: "forbidden-join__img",
              "preview-disabled": ""
            }, null, 8, ["src", "fallback-src"]),
            _createVNode(_unref(NEllipsis), {
              style: {"max-width":"181px"},
              class: "inline-text-name"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.companyName), 1)
              ]),
              _: 1
            })
          ]),
          _createTextVNode(" , " + _toDisplayString(i18n.afterSuffix), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_NSpace, {
      class: "forbidden-join__footer",
      size: 12,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NButton, {
          type: "default",
          size: "medium",
          onClick: __props.onCancel,
          style: { width: '80px' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($tt('cancelText')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_unref(ChangeAccountBtn), {
          btnText: $tt('okText'),
          type: "primary",
          isShowRectangle: false,
          scrollbarStyle: {
          maxHeight: '280px',
          marginTop: '4px'
        },
          itemStyle: { margin: '2px 4px' },
          popoverStyle: { width: '296px' }
        }, null, 8, ["btnText"])
      ]),
      _: 1
    })
  ]))
}
}

})